// extracted by mini-css-extract-plugin
export default {"wrapper":"VideoCard_wrapper__+Rflh"};